angular.module("app").directive("previewPopup", [
    '$window',
    '$templateRequest',
    '$interpolate',
    function ($window, $templateRequest, $interpolate) {
        return {
            restrict: "A",
            link: function ($scope) {
                $scope.onPreviewPopup = function () {
                    var myWindow = $window.open("", "MsgWindow", "width=1000,height=800");
                    $templateRequest('views/templates/dialog/globaldialog.html').then(
                        function (html) {
                            html = $interpolate(html)($scope);
                            //var head = myWindow.document.head || myWindow.document.getElementsByTagName('head')[0];
                            myWindow.document.write(html);
                        }
                    );
                }
            }
        }
    }
]);